(() => {
  /**
   * Das Script darf ausschließlich auf der B2C-Domain laufen.
   *
   * B2C:
   * shop.panasiade.com
   *
   * B2B:
   * order.panasiade.com
   * -> dort wird NICHTS verändert.
   */
  const B2C_HOST = 'shop.panasiade.com';

  if (window.location.hostname !== B2C_HOST) {
    return;
  }

  const SEPARATOR = ' x ';

  /**
   * Schneidet alles ab dem ersten " x " ab.
   *
   * Falls dadurch eine geöffnete runde Klammer übrig bleibt,
   * wird diese automatisch geschlossen.
   *
   * Beispiele:
   *
   * Jongga Kimchi Geschnitten 300g x 7 aus PL
   * ->
   * Jongga Kimchi Geschnitten 300g
   *
   * Bonbon Dipping Candy Bear Jelly (45g x 12) x 8
   * ->
   * Bonbon Dipping Candy Bear Jelly (45g)
   */
  function cleanTitle(value) {
    if (!value || !value.includes(SEPARATOR)) {
      return value;
    }

    let cleaned = value.split(SEPARATOR)[0].trim();

    /**
     * Prüfen, ob nach dem Abschneiden mehr öffnende
     * als schließende runde Klammern vorhanden sind.
     */
    const openBrackets = (cleaned.match(/\(/g) || []).length;
    const closeBrackets = (cleaned.match(/\)/g) || []).length;

    /**
     * Fehlende schließende Klammern ergänzen.
     */
    if (openBrackets > closeBrackets) {
      cleaned += ')'.repeat(openBrackets - closeBrackets);
    }

    return cleaned;
  }

  /**
   * Bereinigt alle Text-Nodes innerhalb eines Elements.
   */
  function cleanElement(element) {
    if (!element || element.dataset.cleanProductTitle === 'true') {
      return;
    }

    const walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT
    );

    const textNodes = [];

    while (walker.nextNode()) {
      textNodes.push(walker.currentNode);
    }

    textNodes.forEach((node) => {
      const original = node.nodeValue;

      if (original && original.includes(SEPARATOR)) {
        node.nodeValue = cleanTitle(original);
      }
    });

    /**
     * Accessibility / Tooltips ebenfalls bereinigen.
     */
    ['title', 'aria-label'].forEach((attribute) => {
      if (element.hasAttribute(attribute)) {
        const value = element.getAttribute(attribute);

        if (value && value.includes(SEPARATOR)) {
          element.setAttribute(
            attribute,
            cleanTitle(value)
          );
        }
      }
    });

    element.dataset.cleanProductTitle = 'true';
  }

  /**
   * Produkt-Titel in Ignite finden.
   */
  const selectors = [
    /**
     * Produktlinks:
     * Collection, Search, Recommendations etc.
     */
    'a[href*="/products/"]',

    /**
     * Übliche Product-Title Elemente.
     */
    '.product-title',
    '.product__title',
    '[data-product-title]',
    '[class*="product-title"]',
    '[class*="product__title"]',

    /**
     * Product Cards.
     */
    '[class*="product-card"] [class*="title"]',

    /**
     * Cart / Cart Drawer.
     */
    'cart-drawer a[href*="/products/"]',
    '[class*="cart"] a[href*="/products/"]',

    /**
     * Quick View / Quick Buy.
     */
    '[class*="quick"] a[href*="/products/"]'
  ].join(',');

  /**
   * Scannt einen Bereich der Seite nach Produkttiteln.
   */
  function scan(root = document) {
    if (!root) {
      return;
    }

    /**
     * Sicherheit:
     * Auch bei späteren Aufrufen nur auf B2C-Domain arbeiten.
     */
    if (window.location.hostname !== B2C_HOST) {
      return;
    }

    /**
     * Falls das Root-Element selbst ein Produkttitel ist.
     */
    if (
      root.nodeType === Node.ELEMENT_NODE &&
      root.matches &&
      root.matches(selectors)
    ) {
      cleanElement(root);
    }

    /**
     * Alle passenden Elemente innerhalb des Root-Bereichs.
     */
    if (root.querySelectorAll) {
      root
        .querySelectorAll(selectors)
        .forEach(cleanElement);
    }

    /**
     * Auf Produktdetailseiten zusätzlich H1 und Breadcrumb
     * bereinigen, da der Produkttitel dort nicht zwingend
     * als Produktlink ausgegeben wird.
     */
    if (
      root === document &&
      window.location.pathname.includes('/products/')
    ) {
      document
        .querySelectorAll(
          'main h1, [aria-current="page"]'
        )
        .forEach(cleanElement);
    }
  }

  /**
   * Initialisierung.
   */
  function init() {
    /**
     * Sicherheit:
     * Nur B2C.
     */
    if (window.location.hostname !== B2C_HOST) {
      return;
    }

    /**
     * Initiale Seite bereinigen.
     */
    scan(document);

    /**
     * Dynamisch eingefügte Inhalte beobachten.
     *
     * Damit werden unter anderem berücksichtigt:
     *
     * - Cart Drawer
     * - Predictive Search
     * - Infinite Scroll
     * - Quick View
     * - Quick Buy
     * - Recommendations
     */
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            scan(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    /**
     * Ignite / Theme Events.
     */
    [
      'cart-add',
      'cart-update',
      'cart-drawer-open',
      'quick-view-open',
      'variant-change'
    ].forEach((eventName) => {
      document.addEventListener(eventName, () => {
        requestAnimationFrame(() => {
          scan(document);
        });
      });
    });
  }

  /**
   * Script starten.
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }
})();